// extracted by mini-css-extract-plugin
export default {"tile":"_4db662b0","info":"_7ac5530a"};